import { buildApiUrl, getApiBaseUrl } from './apiConfig';

const API_TIMEOUT = 10000;

const STORAGE_TOKEN_KEY = 'tiempos_auth_token';

type FetchAPIOptions = RequestInit & {
  timeoutMs?: number;
};

function getToken(): string | null {
  return localStorage.getItem(STORAGE_TOKEN_KEY);
}

export async function fetchAPI<T>(
  endpoint: string,
  options: FetchAPIOptions = {}
): Promise<T> {
  const controller = new AbortController();
  const { timeoutMs = API_TIMEOUT, ...requestOptions } = options;
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
  const token = getToken();

  try {
    const response = await fetch(buildApiUrl(endpoint), {
      ...requestOptions,
      signal: controller.signal,
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
        ...requestOptions.headers,
      },
    });

    clearTimeout(timeoutId);

    if (response.status === 401) {
      const body = await response.json().catch(() => ({}));
      const detalle: string = body.detail || '';
      localStorage.removeItem(STORAGE_TOKEN_KEY);
      localStorage.removeItem('tiempos_auth_user');
      // Guardar aviso para mostrar en LoginPage
      const aviso = detalle.toLowerCase().includes('invalidada')
        ? 'Su sesión fue cerrada porque se inició sesión desde otro dispositivo.'
        : 'Su sesión expiró. Inicie sesión nuevamente.';
      sessionStorage.setItem('tiempos_login_aviso', aviso);
      window.location.href = '/login';
      throw new Error(detalle || 'Sesion expirada');
    }

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || errorData.error || `HTTP ${response.status}`);
    }

    return response.json();
  } catch (error: any) {
    clearTimeout(timeoutId);
    if (error.name === 'AbortError') {
      throw new Error('Conexion lenta. Intente nuevamente.');
    }
    if (error instanceof TypeError) {
      throw new Error('No se pudo conectar con el API. Verifique que el backend este activo.');
    }
    throw error;
  }
}

export { STORAGE_TOKEN_KEY, getApiBaseUrl, buildApiUrl };
